<mat-sidenav-container>
  <mat-sidenav [opened]="(state | async)?.open" position="end" disableClose>
    @if ((state | async)?.target === 'menu') {
    <div class="mat-sidenav-container">
      @for (item of appNav; track item) { @if (!item.children) {
      <ecp-sidenav-link [link]="item"> </ecp-sidenav-link>
      } @else {
      <mat-expansion-panel
        [expanded]="step === item.order && (state | async)?.target === 'menu'"
        (opened)="setStep(item.order)"
      >
        <mat-expansion-panel-header collapsedHeight="50px" expandedHeight="50px">
          {{ item.label }}
          <mat-icon class="mat-expansion-panel-icon" svgIcon="menu-expansion"></mat-icon>
        </mat-expansion-panel-header>
        @if (hasChildren(item)) { @for (subPanel of item.children; track subPanel; let subPanelIndex = $index) {
        <mat-expansion-panel
          [expanded]="subStep === subPanelIndex && (state | async)?.target === 'menu'"
          (opened)="setSubStep(subPanelIndex)"
        >
          <mat-expansion-panel-header collapsedHeight="50px" expandedHeight="50px">
            {{ subPanel.label }}
            <mat-icon class="mat-expansion-panel-icon" svgIcon="submenu-expansion"></mat-icon>
          </mat-expansion-panel-header>
          <ecp-sidenav-list [links]="subPanel.children"></ecp-sidenav-list>
        </mat-expansion-panel>
        } } @else {
        <ecp-sidenav-list [links]="item.children"></ecp-sidenav-list>
        }
      </mat-expansion-panel>
      } }
      <ul class="mat-sidenav-secondary-list-links">
        <li>
          <a routerLink="/contact-us">Contact</a>
        </li>
        <li>
          <a href="https://www.essilorusa.com/terms-and-conditions" target="_blank" title="Terms and Conditions"
            >Terms</a
          >
        </li>
        <li>
          <a href="https://www.essilorusa.com/privacy-policy" target="_blank" title="Privacy Policy">Legal</a>
        </li>
      </ul>
    </div>
    } @if ((state | async)?.target === 'user') {
    <div class="mat-sidenav-container">
      @for (item of userNav; track item) { @if (!item.children) {
      <ecp-sidenav-link [red]="true" [link]="item"></ecp-sidenav-link>
      } @else {
      <mat-expansion-panel
        [expanded]="(step === item.order || hasOneItem(item)) && (state | async)?.target === 'user'"
        (opened)="setStep(item.order)"
      >
        <mat-expansion-panel-header collapsedHeight="50px" expandedHeight="50px">
          {{ item.label }}
          <mat-icon class="mat-expansion-panel-icon" svgIcon="menu-expansion"></mat-icon>
        </mat-expansion-panel-header>
        @if (hasChildren(item)) { @for (subPanel of item.children; track subPanel; let subPanelIndex = $index) {
        <mat-expansion-panel
          [expanded]="(subStep === subPanelIndex || hasOneItem(subPanel)) && (state | async)?.target === 'user'"
          (opened)="setSubStep(subPanelIndex)"
        >
          <mat-expansion-panel-header collapsedHeight="50px" expandedHeight="50px">
            {{ subPanel.label }}
            <mat-icon class="mat-expansion-panel-icon" svgIcon="submenu-expansion"></mat-icon>
          </mat-expansion-panel-header>
          <ecp-sidenav-list [links]="subPanel.children"></ecp-sidenav-list>
        </mat-expansion-panel>
        } } @else {
        <ecp-sidenav-list [links]="item.children"></ecp-sidenav-list>
        }
      </mat-expansion-panel>
      } }
    </div>
    }
  </mat-sidenav>

  <ng-content></ng-content>
</mat-sidenav-container>

<ng-template>
  @for (item of appNav; track item) { @if (!item.children) {
  <a class="sidenav__link" [routerLink]="link.link">
    {{ link.label }}
  </a>
  } @else {
  <mat-expansion-panel>
    <mat-expansion-panel-header collapsedHeight="50px" expandedHeight="50px">
      {{ item.label }}
      <mat-icon class="mat-expansion-panel-icon" svgIcon="menu-expansion"></mat-icon>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
  } }
  <div class="sidenav__aux-menu">
    <a href="javascript:;" title="Contact us">Contact</a>
    <a href="javascript:;" title="Terms">Terms</a>
    <a href="javascript:;" title="Legal">Legal</a>
  </div>
</ng-template>
